import { render, staticRenderFns } from "./CaseTypeChart.vue?vue&type=template&id=4e17d98c&"
import script from "./CaseTypeChart.vue?vue&type=script&lang=js&"
export * from "./CaseTypeChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports